import TimelineModel from "../../data/model/timeline";
import { getAboutAbace, getTimeline } from "../../data/services/about_service";
import {
  AssociatedButton,
  FinalText,
  HistoryAboutContainer,
  ImageCard,
  LeftPartHistory,
  LeftTextStyle,
  LeftTitle,
  OutsideColumn,
  RightPartHistory,
  RightTextStyle,
  RightTitle,
  VerticalLine,
  WrapLeftTextAndTitle,
  WrapRightTextAndTitle,
} from "../../styles/HistoryAbout";
import { useEffect, useState } from "react";
import { endpoint } from "../../utils/Constants";
import HistoryInfoModel from "../../data/model/history_info";


export default function HistoryAbout() {
  const [timelineData, setTimelineData] = useState<TimelineModel[]>([]);
  const [aboutData, setAboutData] = useState<HistoryInfoModel | null>(null);

  useEffect(() => {
    async function fetchTimeline() {
      const { eventos } = await getTimeline();
      setTimelineData(eventos);
    }

    async function fetchData() {
      const { sobre } = await getAboutAbace();
      if (sobre.length > 0) {
        setAboutData(sobre[0]);
      }
    }

    fetchData();
    fetchTimeline();
  }, []);

  return (
    <>
      <OutsideColumn>
        {timelineData.map((item, index) => {
          const isEven = index % 2 === 0;
          const imageSrc = item.imagem_Url || item.imagem_Thumbnail_Url || "";

          return (
            <HistoryAboutContainer key={index}>
              <VerticalLine />
              {isEven ? (
                <>
                  <LeftPartHistory>
                    <ImageCard
                      src={imageSrc ? `${endpoint}${imageSrc}` : ""}
                      alt={item.titulo!}
                      style={!imageSrc ? { visibility: "hidden" } : {}}
                    />
                  </LeftPartHistory>
                  <RightPartHistory>
                    <WrapRightTextAndTitle>
                      <RightTitle dangerouslySetInnerHTML={{ __html: item.titulo! }} />
                      <RightTextStyle dangerouslySetInnerHTML={{ __html: item.descricao! }} />
                    </WrapRightTextAndTitle>
                  </RightPartHistory>
                </>
              ) : (
                <>
                  <LeftPartHistory>
                    <WrapLeftTextAndTitle>
                      <LeftTitle dangerouslySetInnerHTML={{ __html: item.titulo! }} />
                      <LeftTextStyle dangerouslySetInnerHTML={{ __html: item.descricao! }} />
                    </WrapLeftTextAndTitle>
                  </LeftPartHistory>
                  <RightPartHistory>
                    <ImageCard
                      src={imageSrc ? `${endpoint}${imageSrc}` : ""}
                      alt={item.titulo!}
                      style={!imageSrc ? { visibility: "hidden" } : {}}
                    />
                  </RightPartHistory>
                </>
              )}
            </HistoryAboutContainer>
          );
        })}
        {aboutData && (
          <>
            <div style={{ padding: "60px" }}></div>
            <FinalText dangerouslySetInnerHTML={{ __html: aboutData.final! }} />
            <div style={{ padding: "60px" }}></div>
          </>
        )}
      </OutsideColumn>
    </>
  );
}
